import { COLOR_OPTIONS } from 'config/style';
import STTypo, { STTypoModels } from 'core/shared/typo';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import type { AppState } from 'redux/app-state';
import type { IHighLevelStatistics } from '../../regional-overview-mycotoxin.models';
import { getTypeArea } from '../../regional-overview-mycotoxin.utils';

interface IRegionalMycotoxinItemListStatistics {
  dataStatisticsMycotoxin: IHighLevelStatistics[] | undefined;
}

const RegionalMycotoxinItemListStatistics = ({ dataStatisticsMycotoxin }: IRegionalMycotoxinItemListStatistics): JSX.Element => {
  const currentUnitSystem = useSelector((state: AppState) => state.uiState.global.currentUnitSystem);
  const [t] = useTranslation();

  return (
    <>
      {dataStatisticsMycotoxin?.map((item: IHighLevelStatistics) => (
        <div
          key={item.name}
          data-testid={`regional-risk-mycotoxin-statistics-list-item-${item.name}`}
          className='high-level-statistics-container__list-climatic-risk__item'>
          <div className='iconRisk' style={{ backgroundColor: item.color }} />
          <div className='risk-name'>
            <STTypo color={COLOR_OPTIONS.NEUTRAL_80} type={STTypoModels.TypeOptions.P1} boldness>
              {item.name}
            </STTypo>
            <STTypo color={COLOR_OPTIONS.NEUTRAL_60} type={STTypoModels.TypeOptions.P2}>
              {item.areaSize} {getTypeArea(currentUnitSystem)} ({item.totalFields}{' '}
              {t('pages.regional_overview.regional_mycotoxin.high_level_statistics.fields')})
            </STTypo>
          </div>
          <div className='value-risk'>
            <STTypo color={COLOR_OPTIONS.NEUTRAL_80} type={STTypoModels.TypeOptions.P1} boldness>
              {item.y}%
            </STTypo>
          </div>
        </div>
      ))}
    </>
  );
};

export default RegionalMycotoxinItemListStatistics;
